import "bootstrap/dist/css/bootstrap.min.css";
import questionsData from "../questions.json";
import type { Question } from "./types";
import { QuestionCard } from "./components";
import { gradeQuiz } from "./quiz";
import { getAttempts } from "./storage";

const questions = questionsData as Question[];

// Render a card component for each question from the imported JSON
const quizContainer = document.querySelector("#quizContainer")!;
for (const question of questions) {
  quizContainer.appendChild(QuestionCard(question));
}

document.querySelector("#totalAttempts")!.textContent =
  `Total Times the quiz was taken: ${getAttempts()}`;

document
  .querySelector("#submitBtn")!
  .addEventListener("click", () => gradeQuiz(questions));
